
// User endpoints
export const homeLink = '/';
export const grilleLink = '/grille-tv';
export const actualitiesLink = '/actualites';
export const directLink = '/direct';
export const contactLink = '/contact';
export const jobLink = '/job';
export const accountLink = '/login';




// Admin endpoints
export const adminLink = '/admin';

export const adminActualityLink = '/admin/actuality';
export const adminActualityCategoryLink = '/admin/actuality/category';
export const adminActualityListLink = '/admin/actuality/list';
export const adminActualityEditLink = '/admin/actuality/edit';

export const adminProgrammeLink = '/admin/programme';
export const adminProgrammeAddLink = '/admin/programme/add';
export const adminProgrammeDetailsLink = '/admin/programme/details';
export const adminProgrammeEditLink = '/admin/programme/edit';


export const adminEmissionLink = '/admin/emission';

export const adminUserLink = '/admin/user';
export const adminUserManageLink = '/admin/user/manage';

export const adminMediaLink = '/admin/media'; 

